import React, { Component } from 'react';
import { withRouter } from 'react-router';
import pathService from './PathService';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { FormGroup, Form, Label, Input, Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { HuePicker, SketchPicker } from 'react-color';

class PathEditPlain extends Component {
	constructor(props) {
		super(props);
		this.state = { entity: null, loading: true };

		const { match } = this.props;
		this.id = match.params.id;
	}

	componentDidMount() {
		this.retrieveFormData();
	}

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.state.entity[name] = value;
		this.setState({ entity: this.state.entity});
	}

	handleClickCancel = () => {
		const { history } = this.props;

		history.push('/paths');
	}

	handleValidSubmit = (event, values) => {
		const { history } = this.props;
		let processedValues = values;
		
		(async () => {
			await pathService.update(this.id, processedValues);
			history.push('/paths');
		})();
	}
	

	renderForm(entity) {
		const { t, i18n } = this.props;
		return (
			<AvForm model={entity} onValidSubmit={this.handleValidSubmit}>
				<AvField name="id" type="hidden" />
				<AvField name="rowVersion" type="hidden" />
				<AvField name="name" label={t('Name')} required errorMessage={t('FieldInvalid')} validate={{
					required: { value: true, errorMessage: t('FieldRequired') },
					minLength: { value: 2}
				}} />
				<AvField name="surveyIntervalMonths" label={ t('SurveyIntervalMonths')} type="number" />
				<AvField name="lengthKilometres" label={t('LengthKilometres')} type="number" step='0.01' />
				<FormGroup>
					<Button>Save</Button>&nbsp;
					<Button onClick={this.handleClickCancel}>Cancel</Button>
				</FormGroup>
			</AvForm>
		);
	}

	render() {
		let contents = this.state.loading
			? <p><em>Loading...</em></p>
			: this.renderForm(this.state.entity);

		return (
			<div>
				<h1 id="tabelLabel">Path State</h1>
				{contents}
			</div>
		);
	}

	async retrieveFormData() {
		const data = await pathService.get(this.id);
		this.setState({ entity: data, loading: false });
	}
}

export const PathEdit = withTranslation()(withRouter(PathEditPlain));